import LiteTradeNotification from "./LiteTradeNotification";
import amountFormat from "../../../../utils/amountFormat";
import _ from "lodash";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { LITE_TRADE_POSITION_SIDE } from "../../liteTradeConstants";

function LiteTradeNotificationBasicInfo(props) {
    const {
        accountType,
        assetInstance,
        children,
        description,
        lotsAmount,
        margin,
        order,
        price,
        status,
        symbol,
        type,
        withCloseButton,
    } = props;

    const {getLangPath} = useLangContext();
    return <LiteTradeNotification accountType={accountType} description={description} status={status} symbol={symbol} type={type}
                                  withCloseButton={withCloseButton}>
        <div className="f14 mt-2" dangerouslySetInnerHTML={{
            __html: getLangPath('lite_version.notifications.basic_info', {
                lots_amount: amountFormat(Math.abs(lotsAmount) || 0, 2),
                margin: `${amountFormat(Math.abs(margin) || 0, 2)}`,
                order_type: getLangPath(`lite_version.order.types.${_.toLower(order.type)}.price`),
                price: assetInstance.roundAmount(price || 0),
                side: _.capitalize(getLangPath(`lite_version.order.${_.toLower(order.side) === LITE_TRADE_POSITION_SIDE.BUY ? 'buy' : 'sell'}`)),
            })
        }}/>
        {!!children && children}
    </LiteTradeNotification>
}

export default LiteTradeNotificationBasicInfo;
